import React from 'react';
import { Link } from 'react-router-dom';

const Terms = () => {
  return (
    <div className="max-w-4xl mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold text-gray-900 mb-6">Terms of Service</h1>
      
      <div className="prose prose-indigo prose-lg text-gray-500 mx-auto">
        <p className="lead">
          These Terms of Service ("Terms") govern your access to and use of RankTheBlank.js. Please read these Terms carefully.
        </p>
        
        <h2>Acceptance of Terms</h2>
        <p>
          By accessing or using RankTheBlank.js, you agree to be bound by these Terms and our Privacy Policy.
          If you do not agree to these Terms, you may not access or use RankTheBlank.js.
        </p>
        
        <h2>Changes to Terms</h2>
        <p>
          We may revise these Terms from time to time. If we make changes, we will notify you by revising
          the date at the top of these Terms and, in some cases, we may provide you with additional notice.
          Your continued use of RankTheBlank.js after the changes have been made will constitute your acceptance
          of the changes.
        </p>
        
        <h2>Account Registration</h2>
        <p>
          To use certain features of RankTheBlank.js, you may need to register for an account. When you register,
          you must provide accurate and complete information. You are responsible for maintaining the security of your
          account and password. We cannot and will not be liable for any loss or damage resulting from your failure
          to comply with this security obligation.
        </p>
        
        <h2>User Content</h2>
        <p>
          RankTheBlank.js allows you to create polls, vote in polls, and share polls with others. You are solely
          responsible for the content you submit through RankTheBlank.js.
        </p>
        <p>
          By submitting content through RankTheBlank.js, you grant us a worldwide, non-exclusive, royalty-free
          license to use, copy, modify, and display that content in connection with the services we provide to you
          and the promotion of RankTheBlank.js.
        </p>
        
        <h2>Prohibited Conduct</h2>
        <p>
          You agree not to engage in any of the following prohibited activities:
        </p>
        <ul>
          <li>Using RankTheBlank.js for any illegal purpose or in violation of any laws</li>
          <li>Posting or transmitting content that is offensive, abusive, libelous, or otherwise objectionable</li>
          <li>Attempting to interfere with, compromise the system integrity or security, or decipher any transmissions to or from the servers</li>
          <li>Taking any action that imposes an unreasonable or disproportionately large load on our infrastructure</li>
          <li>Using any robot, spider, or other automated device to access RankTheBlank.js</li>
          <li>Impersonating another person or entity</li>
        </ul>
        
        <h2>Termination</h2>
        <p>
          We reserve the right to terminate or suspend your account and access to RankTheBlank.js at our sole discretion,
          without notice, for conduct that we believe violates these Terms or is harmful to other users of RankTheBlank.js,
          us, or third parties, or for any other reason.
        </p>
        
        <h2>Disclaimer of Warranties</h2>
        <p>
          RankTheBlank.js is provided "as is" and "as available" without any warranties of any kind, either express or
          implied. We disclaim all warranties, including but not limited to implied warranties of merchantability,
          fitness for a particular purpose, and non-infringement.
        </p>
        
        <h2>Limitation of Liability</h2>
        <p>
          In no event will we be liable for any indirect, special, incidental, consequential, or punitive damages
          arising out of or related to your use of RankTheBlank.js.
        </p>
        
        <h2>Governing Law</h2>
        <p>
          These Terms and your access to and use of RankTheBlank.js will be governed by and construed in accordance
          with the laws of your jurisdiction, without regard to its conflict of laws provisions.
        </p>
        
        <h2>Contact Information</h2>
        <p>
          If you have any questions about these Terms, please contact us at:
          <br />
          <a href="mailto:terms@ranktheblank.js">terms@ranktheblank.js</a>
        </p>
        
        <div className="mt-8">
          <Link to="/" className="text-indigo-600 hover:text-indigo-900">
            &larr; Back to Home
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Terms;